import React, { useContext } from "react";
import globalContext from "../Hooks/globalContext";

export const languageAction = (index, language) => {
  switch (index) {
    case "한국어":
      return "한국어";
    case "영어":
      return "English";
    case "중국어":
      return "汉语";
    default:
      return "None";
  }
};

export default (index, _language, element) => {
  let language = "";

  if (_language) {
    language = { state: _language };
  } else {
    const { language: __language } = useContext(globalContext);
    language = __language;
  }

  if (language) {
    switch (language.state) {
      case "korean":
        switch (index) {
          case "포인트":
            return "포인트";
          case "언어":
            return "언어";
          case "OTP가 초기화되었습니다. 재등록해주세요.":
            return "OTP가 초기화되었습니다. 재등록해주세요.";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "잠금상태입니다. 잠시 후에 다시 시도해주세요.";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "비밀번호 3회 오류로 5분간 송금이 제한됩니다.";
          case "잘못된 OTP 인증번호입니다.":
            return "잘못된 OTP 인증번호입니다.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "서버 오류입니다. 잠시 후에 다시 시도해주세요.";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "등록한 OTP의 6자리 번호를 입력해주세요.";
          case "OTP 등록":
            return "OTP 등록";
          case "OTP 재설정":
            return "OTP 재설정";
          case "OTP 키가 복사되었습니다.":
            return "OTP 키가 복사되었습니다.";
          case "OTP 인증번호 6자리를 입력하세요.":
            return "OTP 인증번호 6자리를 입력하세요.";
          case "OTP가 등록되었습니다.":
            return "OTP가 등록되었습니다.";
          case "잘못된 OTP 인증번호입니다.":
            return "잘못된 OTP 인증번호입니다.";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "등록한 OTP의 6자리 번호를 입력해주세요.";
          case "앱에 해당 OTP 키를 입력해주세요.":
            return "앱에 해당 OTP 키를 입력해주세요.";
          case "새로운 OTP를 등록합니다.":
            return "새로운 OTP를 등록합니다.";
          case "OTP가":
            return "OTP가";
          case "등록된 상품이 없습니다.":
            return "등록된 상품이 없습니다.";
          case "구매 기록":
            return "구매 기록";
          case "주문 완료":
            return "주문 완료";
          case "배송 준비":
            return "배송 준비";
          case "배송 중":
            return "배송 중";
          case "배송 완료":
            return "배송 완료";
          case "주문이 정상적으로 처리되었습니다.":
            return "주문이 정상적으로 처리되었습니다.";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.";
          case "현재 결제 가능 금액보다 결제할 금액이 더 큽니다.":
            return "현재 결제 가능 금액보다 결제할 금액이 더 큽니다.";
          case "자기 자신에게는 보낼 수 없습니다.":
            return "자기 자신에게는 보낼 수 없습니다.";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "잠금상태입니다. 잠시 후에 다시 시도해주세요.";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "비밀번호 3회 오류로 5분간 송금이 제한됩니다.";
          case "잘못된 비밀번호입니다.":
            return "잘못된 비밀번호입니다.";
          case "2차 비밀번호를 입력하세요.":
            return "2차 비밀번호를 입력하세요.";
          case "OTP 인증번호를 입력하세요.":
            return "OTP 인증번호를 입력하세요.";
          case "두 비밀번호가 다릅니다.":
            return "두 비밀번호가 다릅니다.";
          case "새 비밀번호가 등록되었습니다.":
            return "새 비밀번호가 등록되었습니다.";
          case "2차 비밀번호가":
            return "2차 비밀번호가";
          case "등록되지 않았습니다.":
            return "등록되지 않았습니다.";
          case "새 비밀번호를 등록합니다.":
            return "새 비밀번호를 등록합니다.";
          case "이전":
            return "이전";
          case "2차 비밀번호를 입력해주세요.":
            return "2차 비밀번호를 입력해주세요.";
          case "입력하신 비밀번호를 확인합니다.":
            return "입력하신 비밀번호를 확인합니다.";
          case "결제":
            return "결제";
          case "다음":
            return "다음";
          case "지갑 정보":
            return "지갑 정보";
          case "LCMS 잔액":
            return "LCMS 잔액";
          case "결제 정보":
            return "결제 정보";
          case "결제 금액":
            return "결제 금액";
          case "배송지":
            return "배송지";
          case "수량":
            return "수량";
          case "할인 금액":
            return "할인 금액";
          case "총 결제 금액":
            return "총 결제 금액";
          case "상품 정보":
            return "상품 정보";
          case "정보":
            return "정보";
          case "상품명":
            return "상품명";
          case "회원가입이 완료되었습니다. 입력하신 정보로 로그인해주세요.":
            return "회원가입이 완료되었습니다. 입력하신 정보로 로그인해주세요.";
          case "주소를 입력해주세요.":
            return "주소를 입력해주세요.";
          case "주소":
            return "주소";
          case "주소 상세":
            return "주소 상세";
          case "전화번호":
            return "전화번호";
          case "구매하기":
            return "구매하기";
          case "기록이 없습니다.":
            return "기록이 없습니다.";
          case "최대":
            return "최대";
          case "스테이킹할 갯수를 입력하세요.":
            return "스테이킹할 갯수를 입력하세요.";
          case "기간":
            return "기간";
          case "이자율":
            return "이자율";
          case "수량":
            return "수량";
          case "기댓값":
            return "기댓값";
          case "스테이킹 중":
            return "스테이킹 중";
          case "스테이킹":
            return "스테이킹";
          case "올바른 수량을 입력해주세요.":
            return "올바른 수량을 입력해주세요.";
          case "스테이킹 하려는 금액이 현재 잔액보다 큽니다.":
            return "스테이킹 하려는 금액이 현재 잔액보다 큽니다.";
          case "앱 설정이 일치하지 않습니다. 앱을 재부팅 후 다시 시도해주세요.":
            return "앱 설정이 일치하지 않습니다. 앱을 재부팅 후 다시 시도해주세요.";
          case "스테이킹하려는 갯수가 최소 스테이킹 갯수보다 적습니다.":
            return "스테이킹하려는 갯수가 최소 스테이킹 갯수보다 적습니다.";
          case "개의 토큰이 스테이킹 되었습니다." /** e.g.) 100개의 토큰이... 10개의 토큰이.. 등 숫자가 맨 앞에 옴.*/:
            return "개의 토큰이 스테이킹 되었습니다.";
          case "모두 받기":
            return "모두 받기";
          case "지급 비율":
            return "지급 비율";
          case "스테이킹 중":
            return "스테이킹 중";
          case "보상 수령 가능":
            return "보상 수령 가능";
          case "지급 됨":
            return "지급 됨";
          case "스테이킹 상태":
            return "스테이킹 상태";
          case "수령 가능한 보상이 없습니다.":
            return "수령 가능한 보상이 없습니다.";
          case "포인트가 지급되었습니다." /** e.g.) 100 포인트가 .. 200 포인트가... 등 포인트 값 n이 맨 앞에 옴 */:
            return "포인트가 지급되었습니다.";
          case "길게 눌러서 새로고침":
            return "길게 눌러서 새로고침";
          case "2차 비밀번호 변경":
            return "2차 비밀번호 변경";
          case "등록된 2차 비밀번호를 입력해주세요.":
            return "등록된 2차 비밀번호를 입력해주세요.";
          case "새 2차 비밀번호를 입력해주세요.":
            return "새 2차 비밀번호를 입력해주세요.";
          case "현재 스테이킹 가능 금액보다 입력한 금액이 더 큽니다.":
            return "현재 스테이킹 가능 금액보다 입력한 금액이 더 큽니다.";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.";
          case "송금 가능액":
            return "송금 가능액";
          case "현재 스테이킹이 가능한 상태가 아닙니다.":
            return "현재 스테이킹이 가능한 상태가 아닙니다.";
          case "* 기존 지갑을 등록할 시에는 스테이킹 기능을 이용할 수 없습니다. 이용에 참고하세요.":
            return "* 기존 지갑을 등록할 시에는 스테이킹 기능을 이용할 수 없습니다. 이용에 참고하세요.";
          case "지갑이 등록되었습니다. 다시 로그인 해주세요.":
            return "지갑이 등록되었습니다. 다시 로그인 해주세요.";
          case "스테이킹 불가 계정입니다.":
            return "스테이킹 불가 계정입니다.";
          case "초기화":
            return "초기화";
          case "모든 항목을 입력해주세요.":
            return "모든 항목을 입력해주세요.";
          case "올바른 연락처를 입력해주세요.":
            return "올바른 연락처를 입력해주세요.";
          case "컨트랙트 호출":
            return "컨트랙트 호출";
          case "수수료가 너무 낮으면 트랜잭션이 거부될 수 있습니다.":
            return "수수료가 너무 낮으면 트랜잭션이 거부될 수 있습니다.";
          case "존재하지 않는 ID 입니다.":
            return "존재하지 않는 ID 입니다.";
          case "잘못된 ID 혹은 비밀번호입니다.":
            return "잘못된 ID 혹은 비밀번호입니다.";
          case "인증번호 전송":
            return "인증번호 전송";
          case "인증":
            return "인증";
          case "중복된 ID 입니다.":
            return "중복된 ID 입니다.";
          case "로그인":
            return "로그인";
          case "홈":
            return "홈";
          case "등록할 지갑 정보":
            return "등록할 지갑 정보";
          case "내역이 없습니다.":
            return "내역이 없습니다.";
          case "추천 코드":
            return "추천 코드";
          case "회원가입":
            return "회원가입";
          case "비밀번호 찾기":
            return "비밀번호 찾기";
          case "이메일":
            return "이메일";
          case "패키지를 선택해주세요.":
            return "패키지를 선택해주세요.";
          case "비밀번호":
            return "비밀번호";
          case "비밀번호 확인":
            return "비밀번호 확인";
          case "추천인":
            return "추천인";
          case "돌아가기":
            return "돌아가기";
          case "더 보기":
            return "더 보기";
          case "확인":
            return "확인";
          case "약관":
            return "약관";
          case "삭제":
            return "삭제";
          case "로그아웃":
            return "로그아웃";
          case "지갑":
            return "지갑";
          case "히스토리":
            return "히스토리";
          case "출금":
            return "출금";
          case "자산":
            return "자산";
          case "잔액":
            return "잔액";
          case "수수료":
            return "수수료";
          case "가스":
            return "가스";
          case "송금":
            return "송금";
          case "별명":
            return "별명";
          case "등록":
            return "등록";
          case "지갑 주소":
            return "지갑 주소";
          case "받는 지갑주소":
            return "받는 지갑주소";
          case "보낼 금액":
            return "보낼 금액";
          case "비밀번호 변경":
            return "비밀번호 변경";
          case "추천인 코드":
            return "추천인 코드";
          case "가격":
            return "갸격";
          case "설정":
            return "설정";
          case "클립보드로 복사":
            return "클립보드로 복사";
          case "보낸 항목":
            return "보낸 항목";
          case "받은 항목":
            return "받은 항목";
          case "보낼 금액을 입력하세요.":
            return "보낼 금액을 입력하세요.";
          case "수수료를 선택하세요.":
            return "수수료를 선택하세요.";
          case "나의 자산":
            return "나의 자산";
          case "빠름":
            return "빠름";
          case "보통":
            return "보통";
          case "느림":
            return "느림";
          case "등록된 지갑이 없습니다.":
            return "등록된 지갑이 없습니다.";
          case "올바른 지갑주소가 아닙니다.":
            return "올바른 지갑주소가 아닙니다.";
          case "지갑주소가 존재하지 않습니다.":
            return "지갑주소가 존재하지 않습니다.";
          case "받는 사람의 주소를 입력하세요.":
            return "받는 사람의 주소를 입력하세요.";
          case "개인 키를 입력하세요.":
            return "개인 키를 입력하세요.";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "개인 키는 서버에 저장되지 않습니다.";
          case "지갑 주소가 복사되었습니다.":
            return "지갑 주소가 복사되었습니다.";
          case "기록이 존재하지 않습니다.":
            return "기록이 존재하지 않습니다.";
          case "추천인 코드가 복사되었습니다.":
            return "추천인 코드가 복사되었습니다.";
          case "성공적으로 처리되었습니다.":
            return "성공적으로 처리되었습니다.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "서버 오류입니다. 잠시 후에 다시 시도해주세요.";
          case "잠시 후에 다시 시도해주세요.":
            return "잠시 후에 다시 시도해주세요.";
          case "추천인 코드를 등록했습니다.":
            return "추천인 코드를 등록했습니다.";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "이미 등록된 추천인 코드가 있습니다.";
          case "자기 자신은 등록할 수 없습니다.":
            return "자기 자신은 등록할 수 없습니다.";
          case "잔액이 부족합니다.":
            return "잔액이 부족합니다.";
          case "출금 신청이 완료되었습니다.":
            return "출금 신청이 완료되었습니다.";
          case "잘못된 요청입니다.":
            return "잘못된 요청입니다.";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "인증에 실패하였습니다. 재로그인 해주세요.";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "비밀번호가 변경되었습니다. 다시 로그인해주세요.";
          case "두 비밀번호가 맞지 않습니다.":
            return "두 비밀번호가 맞지 않습니다.";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "보안을 위해 로그아웃합니다. 다시 로그인해주세요.";
          case "출금할 금액을 입력하세요.":
            return "출금할 금액을 입력하세요.";
          case "전송 오류입니다.":
            return "전송 오류입니다.";
          case "트랜잭션 전송 완료.":
            return "트랜잭션 전송 완료.";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "시간 초과입니다. 처음부터 다시 시도해주세요.";
          case "존재하지 않는 E-Mail입니다.":
            return "존재하지 않는 E-Mail입니다.";
          case "잘못된 코드입니다.":
            return "잘못된 코드입니다.";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.";
          case "비밀번호 변경이 완료되었습니다.":
            return "비밀번호 변경이 완료되었습니다.";
          case "개인 키가 복사되었습니다.":
            return "개인 키가 복사되었습니다.";
          case "인증 번호를 전송했습니다.":
            return "인증 번호를 전송했습니다.";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "5분 안에 이메일에 전송된 코드를 입력하세요.";
          case "중복된 E-Mail입니다.":
            return "중복된 E-Mail입니다.";
          case "존재하지 않는 추천인입니다.":
            return "존재하지 않는 추천인입니다.";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "잘못된 E-Mail 혹은 비밀번호입니다.";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "당신의 지갑주소입니다. QR코드를 스캔하세요.";
          case "개인 키를 클릭하여 복사하세요.":
            return "개인 키를 클릭하여 복사하세요.";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "개인 키는 반드시 별도로 저장해주세요.";
          case "* 서버에 저장되지 않습니다. *":
            return "* 서버에 저장되지 않습니다. *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "지갑 주소를 클릭하여 복사하세요.";

          case "알림":
            return "알림";
          case "자동 로그인":
            return "자동 로그인";
          case "이메일 인증":
            return "이메일 인증";
          case "코인":
            return "코인";
          case "잔고 확인":
            return "잔고 확인";
          case "ETH 보내기":
            return "ETH 보내기";
          case "아이디":
            return "아이디";
          case "레퍼럴 코드":
            return "레퍼럴 코드";
          case "주소 공유":
            return "주소 공유";
          case "주소 복사":
            return "주소 복사";
          case "받을사람 주소":
            return "받을사람 주소";
          case "답변완료":
            return "답변완료";
          case "보낼 수량":
            return "보낼 수량";
          case "제목":
            return "제목";
          case "ETH 잔액":
            return "ETH 잔액";
          case "지갑 생성":
            return "지갑 생성";
          default:
            return "None";
        }

      /**
       * *************************************************************
       */
      case "chinese":
        switch (index) {
          case "포인트":
            return "Point";
          case "언어":
            return "语言";
          case "OTP가 초기화되었습니다. 재등록해주세요.":
            return "OTP 初始化 。 请重新登记。.";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "是锁定状态。 请稍后再试.";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "密码错误3次，汇款限制5分钟。";
          case "잘못된 OTP 인증번호입니다.":
            return "无效的 OTP 验证码";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "服务器错误 。 请稍后再试";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "请输入已登记的OTP的6位数编号";
          case "OTP 등록":
            return "OTP 注册";
          case "OTP 재설정":
            return "OTP 重置";
          case "OTP 키가 복사되었습니다.":
            return "OTP 密钥已复制";
          case "OTP 인증번호 6자리를 입력하세요.":
            return "请输入OTP 验证码 6 位";
          case "OTP가 등록되었습니다.":
            return "OTP已登记。";
          case "잘못된 OTP 인증번호입니다.":
            return "无效的 OTP 验证码 。";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "请输入已登记的OTP的6位数编号。";
          case "앱에 해당 OTP 키를 입력해주세요.":
            return "请在APP中输入相应OTP密钥.";
          case "새로운 OTP를 등록합니다.":
            return "注册新的OTP";
          case "OTP가":
            return "OTP";
          case "등록된 상품이 없습니다.":
            return "没有登记的商品。";
          case "구매 기록":
            return "采购记录";
          case "주문 완료":
            return "订购完毕";
          case "배송 준비":
            return "配送准备";
          case "배송 중":
            return "配送中";
          case "배송 완료":
            return "配送完毕";
          case "주문이 정상적으로 처리되었습니다.":
            return "订单已正常处理";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "发送的金额比现在可以汇款的金额更大";
          case "현재 결제 가능 금액보다 결제할 금액이 더 큽니다.":
            return "与现在可结算的金额相比，要结算的金额更大.";
          case "자기 자신에게는 보낼 수 없습니다.":
            return "不能送走自己";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "是锁定状态。 请稍后再试";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "密码错误3次，汇款限制5分钟";
          case "잘못된 비밀번호입니다.":
            return "错误的密码";
          case "2차 비밀번호를 입력하세요.":
            return "请输入2次密码";
          case "OTP 인증번호를 입력하세요.":
            return "请输入OTP验证码.";
          case "두 비밀번호가 다릅니다.":
            return "两个密码不一样";
          case "새 비밀번호가 등록되었습니다.":
            return "新密码已登录 ";
          case "2차 비밀번호가":
            return "第2个密码";
          case "등록되지 않았습니다.":
            return "未登记";
          case "새 비밀번호를 등록합니다.":
            return "注册新密码";
          case "이전":
            return "以前";
          case "2차 비밀번호를 입력해주세요.":
            return "请输入2次密码";
          case "입력하신 비밀번호를 확인합니다.":
            return "确认您输入的密码";
          case "결제":
            return "结清";
          case "다음":
            return "下一个";
          case "지갑 정보":
            return "钱包信息";
          case "LCMS 잔액":
            return "LCMS余额";
          case "결제 정보":
            return "支付信息";
          case "결제 금액":
            return "结算金额";
          case "배송지":
            return "配送地";
          case "수량":
            return "数量";
          case "할인 금액":
            return "贴现金额";
          case "총 결제 금액":
            return "结算总额";
          case "상품 정보":
            return "产品信息";
          case "정보":
            return "资讯息";
          case "상품명":
            return "商品名称";
          case "회원가입이 완료되었습니다. 입력하신 정보로 로그인해주세요.":
            return "会员注册已完成。 请用您输入的信息登录";
          case "주소를 입력해주세요.":
            return "请输入地址。.";
          case "주소":
            return "住址";
          case "주소 상세":
            return "地址详情";
          case "전화번호":
            return "电话号码";
          case "구매하기":
            return "购买";
          case "기록이 없습니다.":
            return "无记录";
          case "최대":
            return "最大值";
          case "스테이킹할 갯수를 입력하세요.":
            return "请输入要牛排的个数。.";
          case "기간":
            return "期间";
          case "이자율":
            return "利率";
          case "수량":
            return "数量";
          case "기댓값":
            return "期望值";
          case "스테이킹 중":
            return "正在牛排";
          case "스테이킹":
            return "牛排";
          case "올바른 수량을 입력해주세요.":
            return "请输入正确的数量。";
          case "스테이킹 하려는 금액이 현재 잔액보다 큽니다.":
            return "要牛排的金额大于当前余额。";
          case "앱 설정이 일치하지 않습니다. 앱을 재부팅 후 다시 시도해주세요.":
            return "应用程序设置不一致。 请重新启动应用程序后重新尝试。";
          case "스테이킹하려는 갯수가 최소 스테이킹 갯수보다 적습니다.":
            return "要牛排的个数少于最小牛排的个数。";
          case "개의 토큰이 스테이킹 되었습니다." /** e.g.) 100개의 토큰이... 10개의 토큰이.. 등 숫자가 맨 앞에 옴.*/:
            return "几个代币已经排好了。";
          case "모두 받기":
            return "全部收下";
          case "지급 비율":
            return "支付比率";
          case "스테이킹 중":
            return "正在牛排";
          case "보상 수령 가능":
            return "可领取补偿";
          case "지급 됨":
            return "已支付됨";
          case "스테이킹 상태":
            return "排位状态";
          case "수령 가능한 보상이 없습니다.":
            return "没有可领取的补偿。";
          case "포인트가 지급되었습니다." /** e.g.) 100 포인트가 .. 200 포인트가... 등 포인트 값 n이 맨 앞에 옴 */:
            return "已支付积分。";
          case "길게 눌러서 새로고침":
            return "长按刷新";
          case "2차 비밀번호 변경":
            return "第2次密码变更";
          case "등록된 2차 비밀번호를 입력해주세요.":
            return "请输入已登记的2次密码。";
          case "새 2차 비밀번호를 입력해주세요.":
            return "请输入新的2次密码。";
          case "현재 스테이킹 가능 금액보다 입력한 금액이 더 큽니다.":
            return "现在输入的金额大于可做牛排的金额。";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "发送的金额比现在可以汇款的金额更大。";
          case "송금 가능액":
            return "可汇款额";
          case "현재 스테이킹이 가능한 상태가 아닙니다.":
            return "现在不是可以加载的状态 ";
          case "* 기존 지갑을 등록할 시에는 스테이킹 기능을 이용할 수 없습니다. 이용에 참고하세요.":
            return "* 登记现有钱包时不能使用支架功能。 使用时请参考。";
          case "지갑이 등록되었습니다. 다시 로그인 해주세요.":
            return "钱包已登记。 请重新登录。";
          case "스테이킹 불가 계정입니다.":
            return "无法寄宿账号。";
          case "초기화":
            return "初始化";
          case "모든 항목을 입력해주세요.":
            return "请输入所有项目。";
          case "올바른 연락처를 입력해주세요.":
            return "请输入正确的联系方式。";
          case "컨트랙트 호출":
            return "调用集装箱";
          case "수수료가 너무 낮으면 트랜잭션이 거부될 수 있습니다.":
            return "手续费太低可能会拒绝交易。";
          case "존재하지 않는 ID 입니다.":
            return "不存在的ID。";
          case "잘못된 ID 혹은 비밀번호입니다.":
            return "无效的 ID 或密码 。";
          case "인증번호 전송":
            return "发送验证码";
          case "인증":
            return "认证";
          case "중복된 ID 입니다.":
            return "重复的 ID 。";
          case "로그인":
            return "登录";
          case "홈":
            return "家";
          case "등록할 지갑 정보":
            return "要注册的钱包信息";
          case "내역이 없습니다.":
            return "无明细。";
          case "추천 코드":
            return "推荐代码";
          case "회원가입":
            return "注册会员";
          case "비밀번호 찾기":
            return "查找密码";
          case "이메일":
            return "电邮";
          case "패키지를 선택해주세요.":
            return "请选择套餐。";
          case "비밀번호":
            return "密码";
          case "비밀번호 확인":
            return "密码确认";
          case "추천인":
            return "推荐人";
          case "돌아가기":
            return "返回";
          case "더 보기":
            return "查看更多。";
          case "확인":
            return "确认";
          case "약관":
            return "条款";
          case "삭제":
            return "删除";
          case "로그아웃":
            return "注销";
          case "지갑":
            return "钱包";
          case "히스토리":
            return "历史故事";
          case "출금":
            return "取款";
          case "자산":
            return "资产";
          case "잔액":
            return "余额";
          case "수수료":
            return "佣金";
          case "가스":
            return "天然气";
          case "송금":
            return "汇款";
          case "별명":
            return "别名";
          case "등록":
            return "注册";
          case "지갑 주소":
            return "钱包地址";
          case "받는 지갑주소":
            return "收款钱包地址";
          case "보낼 금액":
            return "发款";
          case "비밀번호 변경":
            return "更改密码";
          case "추천인 코드":
            return "推荐人代码";
          case "가격":
            return "价码";
          case "설정":
            return "设置";
          case "클립보드로 복사":
            return "复制到剪贴板";
          case "보낸 항목":
            return "已发送项目";
          case "받은 항목":
            return "收到的项目";
          case "보낼 금액을 입력하세요.":
            return "请输入要寄出的金额。";
          case "수수료를 선택하세요.":
            return "请选择手续费。";
          case "나의 자산":
            return "我的资产";
          case "빠름":
            return "快捷径";
          case "보통":
            return "寻常";
          case "느림":
            return "迟缓";
          case "등록된 지갑이 없습니다.":
            return "已登记的钱包不存在。";
          case "올바른 지갑주소가 아닙니다.":
            return "不是有效的钱包地址 。";
          case "지갑주소가 존재하지 않습니다.":
            return "钱包地址不存在。";
          case "받는 사람의 주소를 입력하세요.":
            return "请输入收件人的地址。";
          case "개인 키를 입력하세요.":
            return "请输入个人密钥。";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "个人密钥无法保存到服务器 。";
          case "지갑 주소가 복사되었습니다.":
            return "钱包地址已复制 。";
          case "기록이 존재하지 않습니다.":
            return "记录不存在。";
          case "추천인 코드가 복사되었습니다.":
            return "推荐人代码已复制。";
          case "성공적으로 처리되었습니다.":
            return "已成功处理 。";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "服务器错误 。 请稍后再试。";
          case "잠시 후에 다시 시도해주세요.":
            return "请稍后再试";
          case "추천인 코드를 등록했습니다.":
            return "已登记推荐人代码。";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "已登记的推荐人代码已存在。";
          case "자기 자신은 등록할 수 없습니다.":
            return "不能登记自我。";
          case "잔액이 부족합니다.":
            return "余额不足。";
          case "출금 신청이 완료되었습니다.":
            return "取款申请已完成。";
          case "잘못된 요청입니다.":
            return "这是错误的请求。";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "验证失败 。 请重新登录。";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "错误的密码。 请确认后再试。";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "密码已更改。 请重新登录";
          case "두 비밀번호가 맞지 않습니다.":
            return "两个密码不匹配。";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "为安全起见而注销。 请重新登录。";
          case "출금할 금액을 입력하세요.":
            return "请输入应付款金额。";
          case "전송 오류입니다.":
            return "发送错误。";
          case "트랜잭션 전송 완료.":
            return "事务发送完成 。";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "超时了。 请从头再来。";
          case "존재하지 않는 E-Mail입니다.":
            return "不存在的 E-Mail ";
          case "잘못된 코드입니다.":
            return "无效的代码。";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "邮件验证已完成 。 请确认钱包信息。";
          case "비밀번호 변경이 완료되었습니다.":
            return "密码变更已完成。";
          case "개인 키가 복사되었습니다.":
            return "个人密钥已复制 。";
          case "인증 번호를 전송했습니다.":
            return "发送验证码";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "请在5分钟内输入邮件发送的代码。";
          case "중복된 E-Mail입니다.":
            return "重复的 E- Mail 。";
          case "존재하지 않는 추천인입니다.":
            return "不存在的推荐人。";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "无效的 E- Mail 或密码 。";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "这是你的钱包地址。 扫描二维码。";
          case "개인 키를 클릭하여 복사하세요.":
            return "请点击私钥复制。";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "个人钥匙请务必另存。";
          case "* 서버에 저장되지 않습니다. *":
            return "* 无法保存到服务器 。 *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "请点击并复制钱包地址。";

          case "알림":
            return "通知";
          case "자동 로그인":
            return "自动登录";
          case "이메일 인증":
            return "邮箱验证";
          case "코인":
            return "硬币";
          case "잔고 확인":
            return "确认余额";
          case "ETH 보내기":
            return "发送 ETH";
          case "아이디":
            return "用户名";
          case "레퍼럴 코드":
            return "保留代码";
          case "주소 공유":
            return "地址共享";
          case "주소 복사":
            return "复制地址";
          case "받을사람 주소":
            return "收件人地址";
          case "답변완료":
            return "答辩完毕";
          case "보낼 수량":
            return "发货数量";
          case "제목":
            return "题目";
          case "ETH 잔액":
            return "ETH余额";
          case "지갑 생성":
            return "钱包生成";
        }

      case "english":
        switch (index) {
          case "포인트":
            return "Point";
          case "언어":
            return "Language";
          case "OTP가 초기화되었습니다. 재등록해주세요.":
            return "OTP has been initialized. Please re-register.";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "It's locked. Please try again in a little while.";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "The remittance is restricted for 5 minutes due to 3 password errors.";
          case "잘못된 OTP 인증번호입니다.":
            return "Invalid OTP authentication number.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "Server error. Please try again in a little while.";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "Please enter the 6-digit number of the registered OTP.";
          case "OTP 등록":
            return "OTP Registration";
          case "OTP 재설정":
            return "Reset OTP";
          case "OTP 키가 복사되었습니다.":
            return "The OTP key has been copied.";
          case "OTP 인증번호 6자리를 입력하세요.":
            return "Please enter 6 digits of OTP authentication number.";
          case "OTP가 등록되었습니다.":
            return "OTP registered successfully.";
          case "잘못된 OTP 인증번호입니다.":
            return "Invalid OTP authentication number.";
          case "등록한 OTP의 6자리 번호를 입력해주세요.":
            return "Please enter the 6-digit number of the registered OTP.";
          case "앱에 해당 OTP 키를 입력해주세요.":
            return "Please enter the corresponding OTP key in the app.";
          case "새로운 OTP를 등록합니다.":
            return "Register a new OTP.";
          case "OTP가":
            return "OTP is";
          case "등록된 상품이 없습니다.":
            return "There is no registered product.";
          case "구매 기록":
            return "Purchase History";
          case "주문 완료":
            return "Order Completed";
          case "배송 준비":
            return "Preparing for Delievery";
          case "배송 중":
            return "During Delievery";
          case "배송 완료":
            return "Completed Delievery";
          case "주문이 정상적으로 처리되었습니다.":
            return "Your order has been processed normally.";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "The amount to send is larger than the current transferable amount.";
          case "현재 결제 가능 금액보다 결제할 금액이 더 큽니다.":
            return "The amount to be paid is greater than the current amount to be paid.";
          case "자기 자신에게는 보낼 수 없습니다.":
            return "You can't send it to yourself.";
          case "잠금상태입니다. 잠시 후에 다시 시도해주세요.":
            return "It's locked. Please try again in a little while.";
          case "비밀번호 3회 오류로 5분간 송금이 제한됩니다.":
            return "The remittance is restricted for 5 minutes due to 3 password errors.";
          case "잘못된 비밀번호입니다.":
            return "Invalid password.";
          case "2차 비밀번호를 입력하세요.":
            return "Please enter the second password.";
          case "OTP 인증번호를 입력하세요.":
            return "Please enter the OTP authentication number.";
          case "두 비밀번호가 다릅니다.":
            return "The two passwords are different.";
          case "새 비밀번호가 등록되었습니다.":
            return "New password has been registered.";
          case "2차 비밀번호가":
            return "Secondary password is";
          case "등록되지 않았습니다.":
            return "Not registered.";
          case "새 비밀번호를 등록합니다.":
            return "Register a new password.";
          case "이전":
            return "Back";
          case "2차 비밀번호를 입력해주세요.":
            return "Please enter the second password.";
          case "입력하신 비밀번호를 확인합니다.":
            return "Check the password you entered.";
          case "결제":
            return "Order";
          case "다음":
            return "Next";
          case "지갑 정보":
            return "Wallet INFO";
          case "LCMS 잔액":
            return "LCMS Balance";
          case "결제 정보":
            return "Payment INFO";
          case "결제 금액":
            return "Payment Amount";
          case "배송지":
            return "Shipping destination";
          case "수량":
            return "Quantity";
          case "할인 금액":
            return "Discount Amount";
          case "총 결제 금액":
            return "Total Amount Payment";
          case "상품 정보":
            return "Products INFO";
          case "정보":
            return "Information";
          case "상품명":
            return "Products Name";
          case "회원가입이 완료되었습니다. 입력하신 정보로 로그인해주세요.":
            return "Your Join has been completed. Please log in with the information you entered";
          case "주소를 입력해주세요.":
            return "Please enter your address.";
          case "주소":
            return "Address";
          case "주소 상세":
            return "Detail of Address";
          case "전화번호":
            return "Phone Number";
          case "구매하기":
            return "Buy";
          case "기록이 없습니다.":
            return "There is no history.";
          case "최대":
            return "Maximum";
          case "스테이킹할 갯수를 입력하세요.":
            return "Please enter the number of staking.";
          case "기간":
            return "Period";
          case "이자율":
            return "Interest rate";
          case "수량":
            return "Quantity";
          case "기댓값":
            return "Expected Value";
          case "스테이킹 중":
            return "During Staking";
          case "스테이킹":
            return "Staking";
          case "올바른 수량을 입력해주세요.":
            return "Please enter the correct quantity.";
          case "스테이킹 하려는 금액이 현재 잔액보다 큽니다.":
            return "The amount you're trying to stake is greater than the current balance.";
          case "앱 설정이 일치하지 않습니다. 앱을 재부팅 후 다시 시도해주세요.":
            return "App settings do not match. Please reboot the app and try again.";
          case "스테이킹하려는 갯수가 최소 스테이킹 갯수보다 적습니다.":
            return "The number you want to stake is less than the minimum number of staking.";
          case "개의 토큰이 스테이킹 되었습니다." /** e.g.) 100개의 토큰이... 10개의 토큰이.. 등 숫자가 맨 앞에 옴.*/:
            return "Tokens have been staked.";
          case "모두 받기":
            return "Receive All";
          case "지급 비율":
            return "Payment Rate";
          case "스테이킹 중":
            return "During Staking";
          case "보상 수령 가능":
            return "Rewards Available";
          case "지급 됨":
            return "Paid";
          case "스테이킹 상태":
            return "Staking Status";
          case "수령 가능한 보상이 없습니다.":
            return "There are no rewards available.";
          case "포인트가 지급되었습니다." /** e.g.) 100 포인트가 .. 200 포인트가... 등 포인트 값 n이 맨 앞에 옴 */:
            return "Points have been received.";
          case "길게 눌러서 새로고침":
            return "Press and hold to refresh";
          case "2차 비밀번호 변경":
            return "Change Secondary Password";
          case "등록된 2차 비밀번호를 입력해주세요.":
            return "Please enter the registered second password.";
          case "새 2차 비밀번호를 입력해주세요.":
            return "Please enter a new secondary password.";
          case "현재 스테이킹 가능 금액보다 입력한 금액이 더 큽니다.":
            return "The amount entered is larger than the current stakable amount.";
          case "현재 송금 가능 금액보다 보낼 금액이 더 큽니다.":
            return "The amount to send is larger than the current transferable amount.";
          case "송금 가능액":
            return "Send Available";
          case "현재 스테이킹이 가능한 상태가 아닙니다.":
            return "Staking is not currently available.";
          case "* 기존 지갑을 등록할 시에는 스테이킹 기능을 이용할 수 없습니다. 이용에 참고하세요.":
            return "* Staking function is not available when registering an existing wallet. Please refer to this for use.";
          case "지갑이 등록되었습니다. 다시 로그인 해주세요.":
            return "Your wallet has been registered. Please log in again.";
          case "스테이킹 불가 계정입니다.":
            return "This is a non-staking account.";
          case "초기화":
            return "Initialization";
          case "모든 항목을 입력해주세요.":
            return "Please enter everything.";
          case "올바른 연락처를 입력해주세요.":
            return "Please enter a valid contact number.";
          case "컨트랙트 호출":
            return "Contract Call";
          case "수수료가 너무 낮으면 트랜잭션이 거부될 수 있습니다.":
            return "If the fee is too low, the transaction may be rejected.";
          case "존재하지 않는 ID 입니다.":
            return "ID does not exist.";
          case "잘못된 ID 혹은 비밀번호입니다.":
            return "Invalid ID or password.";
          case "인증번호 전송":
            return "Send Authentication Number";
          case "인증":
            return "Authentication";
          case "중복된 ID 입니다.":
            return "It`s Duplicate ID";
          case "로그인":
            return "Login";
          case "홈":
            return "Home";
          case "등록할 지갑 정보":
            return "Wallet information to register";
          case "내역이 없습니다.":
            return "There is no history";
          case "추천 코드":
            return "Recommendation Code";
          case "회원가입":
            return "Join";
          case "비밀번호 찾기":
            return "Find Password";
          case "이메일":
            return "email";
          case "패키지를 선택해주세요.":
            return "Please select a package.";
          case "비밀번호":
            return "Password";
          case "비밀번호 확인":
            return "Check Password";
          case "추천인":
            return "Recommended Member ";
          case "돌아가기":
            return "Back";
          case "더 보기":
            return "More";
          case "확인":
            return "Check";
          case "약관":
            return "Terms";
          case "삭제":
            return "Delete";
          case "로그아웃":
            return "Logout";
          case "지갑":
            return "Wallet";
          case "히스토리":
            return "History";
          case "출금":
            return "Withdrawl";
          case "자산":
            return "Assets";
          case "잔액":
            return "Balance";
          case "수수료":
            return "fee";
          case "가스":
            return "gas";
          case "송금":
            return "send";
          case "별명":
            return "Nickname";
          case "등록":
            return "register";
          case "지갑 주소":
            return "Wallet Address";
          case "받는 지갑주소":
            return "Receiving Wallet Address";
          case "보낼 금액":
            return "Amount to send";
          case "비밀번호 변경":
            return "Change Password";
          case "추천인 코드":
            return "Recommender Code";
          case "가격":
            return "Price";
          case "설정":
            return "Setting";
          case "클립보드로 복사":
            return "opy to Clipboard";
          case "보낸 항목":
            return "Sent History";
          case "받은 항목":
            return "received History";
          case "보낼 금액을 입력하세요.":
            return "Enter the amount you want to send.";
          case "수수료를 선택하세요.":
            return "Please select a fee.";
          case "나의 자산":
            return "My Assets";
          case "빠름":
            return "High";
          case "보통":
            return "Normal";
          case "느림":
            return "Low";
          case "등록된 지갑이 없습니다.":
            return "There is no registered wallet.";
          case "올바른 지갑주소가 아닙니다.":
            return "This is not a valid wallet address.";
          case "지갑주소가 존재하지 않습니다.":
            return "This is not exist Wallet address.";
          case "받는 사람의 주소를 입력하세요.":
            return "Please enter the recipient's address.";
          case "개인 키를 입력하세요.":
            return "Enter your private key.";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "Private keys are not stored on the server.";
          case "지갑 주소가 복사되었습니다.":
            return "Wallet address copied";
          case "기록이 존재하지 않습니다.":
            return "There is no history";
          case "추천인 코드가 복사되었습니다.":
            return "Recommender code has been copied.";
          case "성공적으로 처리되었습니다.":
            return "Processed successfully.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "Server error. Please try again in a little while.";
          case "잠시 후에 다시 시도해주세요.":
            return "Please try again in a little while.";
          case "추천인 코드를 등록했습니다.":
            return "Recommender code registered successfully.";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "There is a recommender code already registered.";
          case "자기 자신은 등록할 수 없습니다.":
            return "You cannot register yourself.";
          case "잔액이 부족합니다.":
            return "Your balance is insufficient";
          case "출금 신청이 완료되었습니다.":
            return "The withdrawal application has been completed.";
          case "잘못된 요청입니다.":
            return "Invalid request.";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "Authentication failed. Please log in again.";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "Invalid password. Please check and try again.";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "Your password has been changed. Please log in again.";
          case "두 비밀번호가 맞지 않습니다.":
            return "The two passwords do not match.";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "Log out for security reasons. Please log in again.";
          case "출금할 금액을 입력하세요.":
            return "Please enter the amount to withdraw.";
          case "전송 오류입니다.":
            return "Transfer error.";
          case "트랜잭션 전송 완료.":
            return "Transaction transfer complete.";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "Timeout. Please try again from the beginning.";
          case "존재하지 않는 E-Mail입니다.":
            return "This is not exist email";
          case "잘못된 코드입니다.":
            return "Invalid code.";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "Mail authentication is complete. Check your wallet information.";
          case "비밀번호 변경이 완료되었습니다.":
            return "Password change is complete.";
          case "개인 키가 복사되었습니다.":
            return "Your private key has been copied.";
          case "인증 번호를 전송했습니다.":
            return "Authentication number sent successfully.";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "Enter the code sent to the email within 5 minutes.";
          case "중복된 E-Mail입니다.":
            return "Duplicated E-Mail.";
          case "존재하지 않는 추천인입니다.":
            return "The recommender does not exist.";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "Invalid E-Mail or password.";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "This is your wallet address. Scan the QR code.";
          case "개인 키를 클릭하여 복사하세요.":
            return "Click the private key to copy it.";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "Please save your private key separately.";
          case "* 서버에 저장되지 않습니다. *":
            return "* It will not be saved on the server.*";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "Click on the wallet address to copy it.";

          case "알림":
            return "Notify";
          case "자동 로그인":
            return "Auto Login";
          case "이메일 인증":
            return "Email authentication";
          case "코인":
            return "Coin";
          case "잔고 확인":
            return "Check Balance";
          case "ETH 보내기":
            return "Send ETH";
          case "아이디":
            return "ID";
          case "레퍼럴 코드":
            return "Reperial Code";
          case "주소 공유":
            return "Address Sharing";
          case "주소 복사":
            return "Address Copy";
          case "받을사람 주소":
            return "To Address";
          case "답변완료":
            return "Answer complete";
          case "보낼 수량":
            return "Amount to Send";
          case "제목":
            return "Name";
          case "ETH 잔액":
            return "ETH Balance";
          case "지갑 생성":
            return "Create Wallet";
          default:
            return "None";
        }

      /**
       * *************************************************************
       */
      default:
        return "None";
    }
  }
};
